export const comoDataTanksTypes = {
  SET_COMO_DATA_TANKS_FILTERS: 'SET_COMO_DATA_TANKS_FILTERS',
  COMO_DATA_TANK_SELECTED: 'COMO_DATA_TANK_SELECTED',
  GET_COMO_DATA_TANK: 'GET_COMO_DATA_TANK',
  CREATE_COMO_DATA_TANK: 'CREATE_COMO_DATA_TANK',
  MOD_COMO_DATA_TANK: 'MOD_COMO_DATA_TANK',
  DELETE_COMO_DATA_TANK: 'DELETE_COMO_DATA_TANK',
  RESET_COMO_DATA_TANK_SELECTED: 'RESET_COMO_DATA_TANK_SELECTED',
  ADD_COMO_DATA_TANK_MODE: 'ADD_COMO_DATA_TANK_MODE',
  EDIT_COMO_DATA_TANK_MODE: 'EDIT_COMO_DATA_TANK_MODE',
  DELETE_COMO_DATA_TANK_MODE: 'DELETE_COMO_DATA_TANK_MODE',
  CLEAR_COMO_DATA_TANKS: 'CLEAR_COMO_DATA_TANKS',
  GET_BRAND_TANK: 'GET_BRAND_TANK',
  GET_CAPACITY_TANK: 'GET_CAPACITY_TANK',
  SET_CONFIG_FILTER_COMO_DATA_TANKS: 'SET_CONFIG_FILTER_COMO_DATA_TANKS',
  SET_CONFIG_PAGE_COMO_DATA_TANKS: 'SET_CONFIG_PAGE_COMO_DATA_TANKS',
  SET_CONFIG_PAGE_SIZE_COMO_DATA_TANKS: 'SET_CONFIG_PAGE_SIZE_COMO_DATA_TANKS',
  SET_CONFIG_SORTED_COMO_DATA_TANKS: 'SET_CONFIG_SORTED_COMO_DATA_TANKS'
}